<template>
  <div class="box" :class="sortBox ? 'sort-box' : ''" v-bind="$attrs">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    sortBox: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.box {
  background-color: var(--box);
  border-radius: 5px;
  padding: 20px;
  overflow: hidden;
  margin-bottom: 30px;
}

.sort-box {
  background-color: #45484D;
  margin-bottom: 5px;
  height: 45px;
}

.box.no-shadow {
  box-shadow: none;
}
</style>